import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { formatDateLong } from '@/shared/formatters';
import type { SentencaArbitralDados } from '../../../types/sentencaArbitral.types';
import { TEXTOS_SENTENCA_ARBITRAL, TITULO_SENTENCA_ARBITRAL } from './secoesSentencaArbitral';
interface SecaoCapaSentencaProps {
  sentenca: Pick<SentencaArbitralDados, 'tipoDecisao' | 'proferidaEm' | 'numeroProcesso' | 'codigoAutenticacao'>;
}
export function SecaoCapaSentenca(t0) {
  const $ = _c(23);
  const {
    sentenca
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-600 w-[3px] flex-none rounded-[2px]" />;
    t2 = <div className="mb-[9px] text-[10.5px] font-semibold tracking-[2.5px] text-neutral-400 uppercase">{TEXTOS_SENTENCA_ARBITRAL.eyebrowCapa}</div>;
    t3 = <h1 className="text-brand-600 m-0 mb-[6px] text-[22px] leading-[1.1] font-semibold tracking-[-0.5px] sm:text-[27px] sm:whitespace-nowrap">{TITULO_SENTENCA_ARBITRAL}</h1>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== sentenca.tipoDecisao) {
    t4 = <div className="flex items-stretch gap-[15px]">{t1}<div>{t2}{t3}<div className="text-[15px] font-semibold text-neutral-500">{sentenca.tipoDecisao}</div></div></div>;
    $[3] = sentenca.tipoDecisao;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image alt="Arbitralis" className="mt-[2px] h-[26px] w-auto flex-none" height={26} src="/Logo.svg" width={110} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="mb-7 flex items-start justify-between gap-4">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== sentenca.proferidaEm) {
    t7 = formatDateLong(sentenca.proferidaEm);
    $[8] = sentenca.proferidaEm;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <CampoCapa rotulo="Proferida em" valor={t7} />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== sentenca.numeroProcesso) {
    t9 = <CampoCapa rotulo={"Processo N\xBA"} valor={sentenca.numeroProcesso} />;
    $[12] = sentenca.numeroProcesso;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== sentenca.codigoAutenticacao) {
    t10 = <CampoCapa rotulo={"Autentica\xE7\xE3o"} valor={sentenca.codigoAutenticacao} />;
    $[14] = sentenca.codigoAutenticacao;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t8 || $[18] !== t9) {
    t11 = <div className="flex flex-wrap items-end justify-between gap-6 pl-[18px]"><div className="flex flex-wrap gap-x-10 gap-y-4">{t8}{t9}{t10}</div></div>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t6) {
    t12 = <div className="border-b border-solid border-neutral-200 px-[37px] pt-[38px] pb-6">{t6}{t11}</div>;
    $[20] = t11;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}
function CampoCapa(t0) {
  const $ = _c(7);
  const {
    rotulo,
    valor
  } = t0;
  let t1;
  if ($[0] !== rotulo) {
    t1 = <div className="mb-[3px] text-[11px] tracking-[0.4px] text-neutral-400 uppercase">{rotulo}</div>;
    $[0] = rotulo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== valor) {
    t2 = <div className="text-[13.5px] text-neutral-700">{valor}</div>;
    $[2] = valor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}